import { useAnalyticsCardBase } from '../../../../hooks/useAnalyticsCardBase'
import type { StatsReportCardProps } from '../../AnalyticsDashboard.types'
import { createStatsData } from '../../utils/createStatsData'

const reportId = 'membership_top_tiers_by_new_members'

type MembershipsTopTiersByNewMembersRow = {
  tier: string
  members: number
}

export const useMembershipsTopTiersByNewMembersReportCard = (): StatsReportCardProps => {
  const analyticsCardBase = useAnalyticsCardBase({ reportId })

  const data = createStatsData<MembershipsTopTiersByNewMembersRow>({
    rows: analyticsCardBase.reportData?.report?.rows,
    mapFn: (row) => ({
      label: row.tier,
      value: row.members,
    }),
  })

  return {
    ...analyticsCardBase,
    type: 'stats',
    data,
    header: {
      ...analyticsCardBase.header,
      label: 'Top tiers by new members',
      tooltip: {
        title: 'Top tiers by new members',
        description:
          'Most popular membership tiers based on amount of newly subscribed members during selected period.',
      },
    },
  }
}
